export type StorageLocationOption = {
  sloc: string;
  description: string;
  plant: string;
};

function normalizeLocationRows(raw: unknown): Record<string, unknown>[] {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw as Record<string, unknown>[];
  return [raw as Record<string, unknown>];
}

/** Parse `/FetchStorageLocation` — legacy bays list (`SLOC_A`, `SLOC_DESC`, `PLANT`). */
export function parseStorageLocationsResponse(data: unknown): StorageLocationOption[] {
  const d = data as Record<string, unknown>;
  const rd = (d.Response_Data ?? d.Response) as Record<string, unknown> | undefined;
  const raw = rd?.item ?? rd?.Item;
  const seen = new Set<string>();
  const out: StorageLocationOption[] = [];

  for (const row of normalizeLocationRows(raw)) {
    const sloc = String(row.SLOC_A ?? row.Sloc ?? '').trim();
    if (!sloc || seen.has(sloc)) continue;
    seen.add(sloc);
    out.push({
      sloc,
      description: String(row.SLOC_DESC ?? row.SlocDesc ?? '').trim(),
      plant: String(row.PLANT ?? row.Plant ?? '').trim(),
    });
  }

  return out.sort((a, b) => a.sloc.localeCompare(b.sloc));
}

export function storageLocationDropdownOptions(
  locations: StorageLocationOption[]
): { value: string; label: string }[] {
  return locations.map((loc) => ({
    value: loc.sloc,
    label: loc.description
      ? `${loc.sloc} — ${loc.description}${loc.plant ? ` (${loc.plant})` : ''}`
      : loc.sloc,
  }));
}
